import { FC } from 'react'
import clsx from 'clsx'
import { SectionHeaderLabel } from './SectionHeaderInfoTooltip'
import { isCategoryAttributeDefinitionRequired } from './utils/categoryAttributeIdentity'

type CategoryAttributeFieldLabelProps = {
  displayName: string
  isRequired?: boolean
  is_required?: boolean
  /** Listing profile: blue Required pill; default layout: legacy asterisk / (Required) */
  variant?: 'listingProfile' | 'legacy'
  additionalInformation?: string | null
  tooltipIdSuffix?: string | number
}

const CategoryAttributeFieldLabel: FC<CategoryAttributeFieldLabelProps> = ({
  displayName,
  isRequired,
  is_required,
  variant = 'legacy',
  additionalInformation,
  tooltipIdSuffix,
}) => {
  const required = isCategoryAttributeDefinitionRequired({ id: 0, isRequired, is_required })

  if (variant === 'listingProfile') {
    return (
      <SectionHeaderLabel
        title={displayName}
        tooltip={additionalInformation || undefined}
        tooltipId={`category-attr-${tooltipIdSuffix ?? displayName}`}
        required={required}
        requiredBadgeStyle="pill"
        className="mb-0"
      />
    )
  }

  return (
    <label
      className={clsx('form-label mb-0', required ? 'required-sm' : '')}
    >
      {displayName}
    </label>
  )
}

export default CategoryAttributeFieldLabel
